import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { PayoutProfile } from '@zero/instrument-details/domain';

@Component({
  selector: 'instrument-details-derivative-data-payout-profile',
  imports: [NgTemplateOutlet, NgClass, TranslocoPipe],
  templateUrl: './derivative-data-payout-profile.component.html',
  styleUrls: ['./derivative-data-payout-profile.component.scss'],
})
export class DerivativeDataPayoutProfileComponent {
  @Input() public payoutProfile: PayoutProfile[] | null = null;
}
